/**
 * Custom Header - Always Sticky Override
 * This script ensures the header stays permanently visible
 * and disables the auto-hide behavior on scroll down
 */

(function() {
  'use strict';

  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPermanentStickyHeader);
  } else {
    initPermanentStickyHeader();
  }

  function initPermanentStickyHeader() {
    const header = document.querySelector('.m-header');
    const headerWrapper = document.querySelector('.m-header__wrapper');
    
    if (!header || !headerWrapper) {
      console.warn('Header elements not found');
      return;
    }

    let lastScrollTop = 0;
    let isScrolling;

    // Force header to be always sticky
    function makeHeaderSticky() {
      // Add stuck class for styling
      header.classList.add('stuck');
      header.classList.add('header-sticky-always');
      
      // Remove scroll direction classes that hide header
      header.classList.remove('scroll-down');
      
      // Ensure wrapper stays visible
      headerWrapper.style.transform = 'translate3d(0, 0, 0)';
      headerWrapper.style.position = 'fixed';
      headerWrapper.style.top = '0';
    }

    // Handle scroll for shadow effect only
    function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      
      // Clear timeout for scroll detection
      window.clearTimeout(isScrolling);
      
      // Add shadow when scrolled down
      if (currentScroll > 20) {
        header.classList.add('stuck');
        headerWrapper.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.1)';
      } else {
        headerWrapper.style.boxShadow = 'none';
      }
      
      // Always keep header visible (override any hiding behavior)
      header.classList.remove('scroll-down');
      header.classList.add('scroll-up', 'stuck', 'header-sticky-always');
      headerWrapper.style.transform = 'translate3d(0, 0, 0)';
      
      // Set scrolling state
      isScrolling = setTimeout(function() {
        // Ensure header remains visible after scrolling stops
        makeHeaderSticky();
      }, 100);
      
      lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    }

    // Initialize on load
    makeHeaderSticky();

    // Listen to scroll events with passive for better performance
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Override the theme's header scroll behavior
    // This targets the MHeader class defined in header.js
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          // If scroll-down class is added, immediately remove it
          if (header.classList.contains('scroll-down')) {
            header.classList.remove('scroll-down');
            header.classList.add('scroll-up');
            headerWrapper.style.transform = 'translate3d(0, 0, 0)';
          }
        }
      });
    });

    // Observe header for class changes
    observer.observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Force sticky on window resize
    window.addEventListener('resize', function() {
      makeHeaderSticky();
    });

    // Ensure body has proper padding to account for fixed header
    function updateBodyPadding() {
      const headerHeight = headerWrapper.offsetHeight;
      document.body.style.paddingTop = headerHeight + 'px';
      
      // Update CSS variable for other components
      document.documentElement.style.setProperty('--m-header-height', headerHeight + 'px');
    }

    updateBodyPadding();
    window.addEventListener('resize', updateBodyPadding);

    console.log('✓ Permanent sticky header initialized');
  }
})();
